var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "no-click-animation": "",
      "persistent": "",
      "width": "500",
      "transition": false
    },
    model: {
      value: _vm.confirmDialog,
      callback: function callback($$v) {
        _vm.confirmDialog = $$v;
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('globals.confirmTitle')))]), _c('v-card-text', [_vm._v(_vm._s(_vm.text))]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function click($event) {
        _vm.confirmDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelBtnName ? _vm.cancelBtnName : _vm.$t('globals.cancelButton')) + " ")]), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function click($event) {
        _vm.confirmed = true;
        _vm.confirmDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmBtnName ? _vm.confirmBtnName : _vm.$t('globals.confirmButton')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }